import React from 'react';
import PropTypes from 'prop-types';
import { omit } from 'lodash';
const Form = (props) => {
    const onSubmit = (e) => {
        e.preventDefault();
        return props.onSubmit && props.onSubmit(e);
    }
    return (props.show !== false && props.hide !== true &&
        <form {...omit(props, ['show', 'hide', 'onSubmit'])} onSubmit={onSubmit}>{props.children}</form>
    )
}
export default Form;
Form.propTypes = {
    onSubmit: PropTypes.func
}